import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { QueryBuilder } from "react-querybuilder";
import { QueryBuilderDnD } from "@react-querybuilder/dnd";
import * as ReactDnD from "react-dnd";
import * as ReactDndHtml5Backend from "react-dnd-html5-backend";
import "react-querybuilder/dist/query-builder.scss";
import "./styles.scss";
import AddFilter from "./renderers/addFilter";
import AddGroup from "./renderers/addGroup";
import NotToggle from "./renderers/notToggle";
import CombinatorSelector from "./renderers/combinatorSelector";
import OperatorSelector from "./renderers/operatorSelector";
import CustomValueEditor from "./renderers/customValueEditor";
import FieldSelector from "./renderers/fieldSelector";
import CloneButton from "./renderers/cloneButton";
import RemoveButton from "./renderers/removeButton";
import { getOperators } from "./helpers/operators";

const SFQueryBuilder = ({
  fields,
  query,
  onChange,
  advancedFilterProps = {
    disableGroup: false,
    disableNotToggle: false,
    disableOrCombinator: false,
  },
}) => {
  const { t } = useTranslation();
  return (
    <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
      <QueryBuilder
        fields={fields}
        query={query}
        showNotToggle={!advancedFilterProps.disableNotToggle}
        addRuleToNewGroups
        showCombinatorsBetweenRules
        independentCombinators
        showCloneButtons
        resetOnOperatorChange
        translations={{
          dragHandle: {
            label: "",
            title: t("components.queryBuilder.dragHandleLabel"),
          },
        }}
        onQueryChange={onChange}
        getOperators={(fieldName) => getOperators(fieldName, fields, t)}
        controlElements={{
          valueEditor: CustomValueEditor,
          fieldSelector: FieldSelector,
          operatorSelector: OperatorSelector,
          addGroupAction: (props) => (
            <AddGroup {...props} disableGroup={advancedFilterProps.disableGroup} />
          ),
          addRuleAction: AddFilter,
          notToggle: NotToggle,
          combinatorSelector: (props) => (
            <CombinatorSelector
              {...props}
              disableOrCombinator={advancedFilterProps.disableOrCombinator}
            />
          ),
          cloneGroupAction: CloneButton,
          cloneRuleAction: CloneButton,
          removeGroupAction: RemoveButton,
          removeRuleAction: RemoveButton,
        }}
      />
    </QueryBuilderDnD>
  );
};

SFQueryBuilder.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      dataType: PropTypes.oneOf(["text", "number", "boolean", "date"]),
      multiple: PropTypes.bool,
      source: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
        })
      ),
      fetchData: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    })
  ).isRequired,
  query: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default SFQueryBuilder;
